<template>
  <div>
    <b-dropdown
      left
      :data-test="`dropdown-button-${index}`"
      variant="plain"
      toggle-class="text-decoration-none"
      no-caret
    >
      <template v-slot:button-content>
        <i class="fas fa-ellipsis-v" />
      </template>
      <span v-show="hasAccess('REPORTING')">
        <b-dropdown-item
          :data-test="`reporting-link-${index}`"
          :to="{ name: 'ReportingApp',
                 params: {
                   campaignId: item.id,
                   advertiserId: item.advertiserId,
                 }
          }"
          v-show="hasAccess('REPORTING')"
          :disabled="isReportingDisabled"
        >
          View Reporting
        </b-dropdown-item>
        <b-dropdown-divider
          v-show="hasAccess('SHOWCASE')"
        />
      </span>
      <b-dropdown-item
        :data-test="`showcase-link-${index}`"
        :to="{ name: 'Campaign Showcase',
               params: {
                 campaignId: item.id,
               }
        }"
        v-show="hasAccess('SHOWCASE')"
      >
        View Showcase
      </b-dropdown-item>
      <span
        v-if="hasAccess('CAMPAIGN')"
      >
        <b-dropdown-divider />
        <b-dropdown-item
          v-if="!item.group"
          @click="onAddCampaignToGroupClick"
          :data-test="`add-campaign-to-group-${index}`"
        >
          Add Campaign To Group
        </b-dropdown-item>
        <b-dropdown-item
          v-else
          @click="removeCampaignFromGroupClick"
          :data-test="`remove-campaign-from-group-${index}`"
        >
          Remove Campaign Group
        </b-dropdown-item>
      </span>
    </b-dropdown>
    <AddCampaignToGroupModal
      ref="addCampaignToGroupModal"
      :id="item.id"
      :advertiser-id="item.advertiserId"
      @refreshTable="refreshTable"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import * as types from '@/modules/campaigns/store/types';
import * as authenticationTypes from '@/modules/authentication/store/types';
import helper from '@/core/helper';

import AddCampaignToGroupModal from '@/modules/campaigns/components/AddCampaignToGroupModal.vue';

export default {
  name: 'CampaignShareActions',
  components: {
    AddCampaignToGroupModal,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      clicked: false,
      isLoading: false,
      campaignName: '',
      checkNameExists: false,
      minAvailableDateForReports: process.env.VUE_APP_MIN_AVAILABLE_REPORTING_DATE,
    };
  },
  computed: {
    ...mapState('account', {
      accountProperties: 'properties',
    }),
    ...mapState('campaigns', [
      'campaigns',
    ]),
    ...mapGetters('authentication', [
      authenticationTypes.GET_IS_ADMIN,
    ]),
    isReportingDisabled() {
      return !this.item.state || this.isInDraft || this.isInReview || this.item.endDate < this.minAvailableDateForReports;
    },
    isInDraft() {
      return this.item.state && this.item.state.toLowerCase() === 'draft';
    },
    isInReview() {
      return this.item.state && this.item.state.toLowerCase() === 'review';
    },
  },
  methods: {
    ...mapActions('campaigns', [
      types.GET_CAMPAIGN_BY_NAME,
      types.PATCH_CAMPAIGN,
    ]),
    hasAccess(shareType) {
      return this.item.shareTypes.includes(shareType) || this.item.shareTypes.includes('CAMPAIGN');
    },
    checkCampaignName: helper.debounce(function checkCampaignName() {
      if (this.campaignName !== '') {
        this.GET_CAMPAIGN_BY_NAME(this.campaignName)
          .then(({ status }) => {
            if (status !== 200) {
              this.checkNameExists = false;
              return;
            }
            this.checkNameExists = true;
          });
      }
      this.checkNameExists = false;
    }, 1000),
    onAddCampaignToGroupClick() {
      this.$refs.addCampaignToGroupModal.showModal();
    },
    removeCampaignFromGroupClick() {
      this.PATCH_CAMPAIGN({ group: '', advertiserId: this.item.advertiserId, id: this.item.id })
        .then(() => {
          this.refreshTable();
        });
    },
    refreshTable() {
      this.$emit('refreshTable');
    },
  },
  watch: {
    campaignName() {
      this.checkCampaignName();
    },
  },
};
</script>
